// extracted by mini-css-extract-plugin
module.exports = {"button":"MessageFormAttachButton_button__2dqCF","label":"MessageFormAttachButton_label__2JIKS","input":"MessageFormAttachButton_input__2kUq7"};